import type { LangCode } from '../data/types.js';

export const LANGS: { code: LangCode; label: string; flag: string }[] = [
  { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'ja', label: '日本語', flag: '🇯🇵' },
  { code: 'th', label: 'ไทย', flag: '🇹🇭' },
  { code: 'id', label: 'Indonesia', flag: '🇮🇩' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
];

const LANG_SET = new Set<string>(LANGS.map((l) => l.code));

const STRINGS: Record<string, Partial<Record<LangCode, string>>> = {
  "header.subtitle": {
    "vi": "Điểm Chụp Ảnh Asakusa",
    "en": "Asakusa Photo Spots",
    "zh": "浅草拍照景点",
    "ja": "浅草フォトスポット",
    "th": "จุดถ่ายรูปอาซากุสะ",
    "id": "Spot Foto Asakusa",
    "es": "Puntos de Fotos en Asakusa"
  },
  "filter.all": {
    "vi": "Tất cả",
    "en": "All Spots",
    "zh": "全部",
    "ja": "すべて",
    "th": "ทั้งหมด",
    "id": "Semua",
    "es": "Todos"
  },
  "filter.day": {
    "vi": "☀️ Ban ngày",
    "en": "☀️ Day",
    "zh": "☀️ 白天",
    "ja": "☀️ 昼間",
    "th": "☀️ กลางวัน",
    "id": "☀️ Siang",
    "es": "☀️ Día"
  },
  "filter.night": {
    "vi": "🌙 Ban đêm",
    "en": "🌙 Night",
    "zh": "🌙 夜间",
    "ja": "🌙 夜",
    "th": "🌙 กลางคืน",
    "id": "🌙 Malam",
    "es": "🌙 Noche"
  },
  "filter.sakura": {
    "vi": "🌸 Mùa Sakura",
    "en": "🌸 Sakura Season",
    "zh": "🌸 樱花季",
    "ja": "🌸 桜シーズン",
    "th": "🌸 ฤดูซากุระ",
    "id": "🌸 Musim Sakura",
    "es": "🌸 Temporada Sakura"
  },
  "filter.momiji": {
    "vi": "🍁 Mùa Momiji",
    "en": "🍁 Momiji Season",
    "zh": "🍁 红叶季",
    "ja": "🍁 紅葉シーズン",
    "th": "🍁 ฤดูใบไม้เปลี่ยนสี",
    "id": "🍁 Musim Momiji",
    "es": "🍁 Temporada Momiji"
  },
  "filter.hot": {
    "vi": "🔥 Hot",
    "en": "🔥 Hot Spots",
    "zh": "🔥 热门",
    "ja": "🔥 人気",
    "th": "🔥 ยอดนิยม",
    "id": "🔥 Populer",
    "es": "🔥 Popular"
  },
  "badge.hot": {
    "vi": "🔥 Hot",
    "en": "🔥 Hot",
    "zh": "🔥 热门",
    "ja": "🔥 人気",
    "th": "🔥 ยอดนิยม",
    "id": "🔥 Populer",
    "es": "🔥 Popular"
  },
  "badge.day": {
    "vi": "☀️ Ban ngày",
    "en": "☀️ Day",
    "zh": "☀️ 白天",
    "ja": "☀️ 昼間",
    "th": "☀️ กลางวัน",
    "id": "☀️ Siang",
    "es": "☀️ Día"
  },
  "badge.night": {
    "vi": "🌙 Ban đêm",
    "en": "🌙 Night",
    "zh": "🌙 夜间",
    "ja": "🌙 夜",
    "th": "🌙 กลางคืน",
    "id": "🌙 Malam",
    "es": "🌙 Noche"
  },
  "badge.sakura": {
    "vi": "🌸 Sakura",
    "en": "🌸 Sakura",
    "zh": "🌸 樱花",
    "ja": "🌸 桜",
    "th": "🌸 ซากุระ",
    "id": "🌸 Sakura",
    "es": "🌸 Sakura"
  },
  "badge.momiji": {
    "vi": "🍁 Momiji",
    "en": "🍁 Momiji",
    "zh": "🍁 红叶",
    "ja": "🍁 紅葉",
    "th": "🍁 โมมิจิ",
    "id": "🍁 Momiji",
    "es": "🍁 Momiji"
  },
  "btn.maps": {
    "vi": "Bản đồ",
    "en": "Maps",
    "zh": "地图",
    "ja": "マップ",
    "th": "แผนที่",
    "id": "Peta",
    "es": "Mapa"
  },
  "btn.share": {
    "vi": "Chia sẻ",
    "en": "Share",
    "zh": "分享",
    "ja": "シェア",
    "th": "แชร์",
    "id": "Bagikan",
    "es": "Compartir"
  },
  "btn.copied": {
    "vi": "Đã sao chép!",
    "en": "Copied!",
    "zh": "已复制！",
    "ja": "コピーしました！",
    "th": "คัดลอกแล้ว!",
    "id": "Disalin!",
    "es": "¡Copiado!"
  },
  "cta.subtitle": {
    "vi": "Muốn có ảnh chuyên nghiệp tại đây?",
    "en": "Want professional photos here?",
    "zh": "想在这里拍专业照片吗？",
    "ja": "ここでプロの写真を撮りませんか？",
    "th": "อยากได้ภาพมืออาชีพที่นี่?",
    "id": "Ingin foto profesional di sini?",
    "es": "¿Quieres fotos profesionales aquí?"
  },
  "cta.book": {
    "vi": "Đặt Chụp Ảnh Kimono →",
    "en": "Book a Kimono Photoshoot →",
    "zh": "预约和服摄影 →",
    "ja": "着物フォト予約 →",
    "th": "จองถ่ายภาพกิโมโน →",
    "id": "Pesan Foto Kimono →",
    "es": "Reservar Sesión de Fotos →"
  },
  "carousel.empty": {
    "vi": "Chưa có ảnh",
    "en": "No photos yet",
    "zh": "暂无照片",
    "ja": "写真はまだありません",
    "th": "ยังไม่มีรูปภาพ",
    "id": "Belum ada foto",
    "es": "Aún no hay fotos"
  },
  "carousel.coming": {
    "vi": "Ảnh sắp có",
    "en": "Photos coming soon",
    "zh": "照片即将上线",
    "ja": "写真は近日公開",
    "th": "รูปภาพเร็วๆ นี้",
    "id": "Foto segera hadir",
    "es": "Fotos próximamente"
  },
  "inspiration.open": {
    "vi": "✨ Ảnh đẹp",
    "en": "✨ Inspiration",
    "zh": "✨ 灵感",
    "ja": "✨ インスピレーション",
    "th": "✨ แรงบันดาลใจ",
    "id": "✨ Inspirasi",
    "es": "✨ Inspiración"
  },
  "inspiration.cta": {
    "vi": "Xem trên bản đồ →",
    "en": "See on map →",
    "zh": "在地图上查看 →",
    "ja": "マップで見る →",
    "th": "ดูบนแผนที่ →",
    "id": "Lihat di peta →",
    "es": "Ver en el mapa →"
  },
  "inspiration.swipeHint": {
    "vi": "Vuốt lên để xem thêm",
    "en": "Swipe up for more",
    "zh": "向上滑动查看更多",
    "ja": "上にスワイプ",
    "th": "ปัดขึ้นเพื่อดูเพิ่มเติม",
    "id": "Geser ke atas",
    "es": "Desliza hacia arriba"
  },
  "tip.label": {
    "vi": "Mẹo chụp ảnh",
    "en": "Photo tip",
    "zh": "拍照技巧",
    "ja": "撮影のコツ",
    "th": "เคล็ดลับถ่ายภาพ",
    "id": "Tips foto",
    "es": "Consejo de foto"
  },
  "welcome.title": {
    "vi": "Điểm Chụp Ảnh Kimono",
    "en": "Kimono Photo Spots",
    "zh": "和服拍照景点",
    "ja": "着物フォトスポット",
    "th": "จุดถ่ายรูปกิโมโน",
    "id": "Spot Foto Kimono",
    "es": "Puntos de Fotos Kimono"
  },
  "welcome.by": {
    "vi": "bởi Kimono Rental Ann",
    "en": "by Kimono Rental Ann",
    "zh": "由 Kimono Rental Ann 提供",
    "ja": "Kimono Rental Ann",
    "th": "โดย Kimono Rental Ann",
    "id": "oleh Kimono Rental Ann",
    "es": "por Kimono Rental Ann"
  },
  "welcome.desc": {
    "vi": "Khám phá những điểm chụp ảnh kimono đẹp nhất quanh Senso-ji. Chạm vào pin để xem ảnh thật và mẹo chụp.",
    "en": "Find the best spots to take beautiful kimono photos around Senso-ji. Tap a pin to see real photos and tips.",
    "zh": "发现浅草寺周围最美的和服拍照景点。点击标记查看实拍照片和拍照技巧。",
    "ja": "浅草寺周辺の着物フォトスポットを見つけましょう。ピンをタップして実際の写真とヒントをご覧ください。",
    "th": "ค้นพบจุดถ่ายรูปกิโมโนที่สวยที่สุดรอบวัดเซนโซจิ แตะที่พินเพื่อดูรูปจริงและเคล็ดลับ",
    "id": "Temukan spot foto kimono terbaik di sekitar Senso-ji. Ketuk pin untuk melihat foto asli dan tips.",
    "es": "Encuentra los mejores lugares para fotos de kimono alrededor de Senso-ji. Toca un pin para ver fotos reales y consejos."
  },
  "welcome.explore": {
    "vi": "Khám Phá Bản Đồ",
    "en": "Explore the Map",
    "zh": "探索地图",
    "ja": "マップを探索",
    "th": "สำรวจแผนที่",
    "id": "Jelajahi Peta",
    "es": "Explorar el Mapa"
  },
  "promo.reviews": {
    "vi": "4.9★ trên Google · 2,000+ đánh giá",
    "en": "4.9★ on Google · 2,000+ reviews",
    "zh": "Google 4.9★ · 2,000+ 评价",
    "ja": "Google 4.9★ · 2,000件以上のレビュー",
    "th": "4.9★ บน Google · 2,000+ รีวิว",
    "id": "4.9★ di Google · 2.000+ ulasan",
    "es": "4.9★ en Google · 2,000+ reseñas"
  },
  "promo.rent": {
    "vi": "Thuê kimono từ ¥5,000",
    "en": "Rent a kimono from ¥5,000",
    "zh": "和服租赁 ¥5,000起",
    "ja": "着物レンタル ¥5,000〜",
    "th": "เช่ากิโมโนเริ่มต้น ¥5,000",
    "id": "Sewa kimono mulai ¥5.000",
    "es": "Alquila un kimono desde ¥5,000"
  },
  "promo.photoshoot": {
    "vi": "Chụp ảnh chuyên nghiệp từ ¥7,000",
    "en": "Professional photoshoot from ¥7,000",
    "zh": "专业摄影 ¥7,000起",
    "ja": "プロ撮影 ¥7,000〜",
    "th": "ถ่ายภาพมืออาชีพเริ่มต้น ¥7,000",
    "id": "Foto profesional mulai ¥7.000",
    "es": "Sesión de fotos profesional desde ¥7,000"
  },
  "promo.hair": {
    "vi": "Làm tóc + phụ kiện đi kèm",
    "en": "Hair styling + accessories included",
    "zh": "含发型设计 + 配饰",
    "ja": "ヘアセット＋小物付き",
    "th": "ทำผม + เครื่องประดับรวมอยู่แล้ว",
    "id": "Tata rambut + aksesoris termasuk",
    "es": "Peinado + accesorios incluidos"
  },
  "promo.walk": {
    "vi": "Cách ga Asakusa 3 phút đi bộ",
    "en": "3 min walk from Asakusa Station",
    "zh": "浅草站步行3分钟",
    "ja": "浅草駅から徒歩3分",
    "th": "เดิน 3 นาทีจากสถานีอาซากุสะ",
    "id": "3 menit jalan dari Stasiun Asakusa",
    "es": "3 min a pie desde la estación Asakusa"
  },
  "promo.temple": {
    "vi": "Cách Senso-ji 1 phút đi bộ",
    "en": "1 min walk to Senso-ji Temple",
    "zh": "步行1分钟到浅草寺",
    "ja": "浅草寺まで徒歩1分",
    "th": "เดิน 1 นาทีถึงวัดเซนโซจิ",
    "id": "1 menit jalan ke Kuil Senso-ji",
    "es": "1 min a pie al Templo Senso-ji"
  },
  "promo.viewPlans": {
    "vi": "Xem Gói",
    "en": "View Plans",
    "zh": "查看套餐",
    "ja": "プランを見る",
    "th": "ดูแพ็คเกจ",
    "id": "Lihat Paket",
    "es": "Ver Planes"
  }
};

export function t(key: string, lang: LangCode): string {
  return STRINGS[key]?.[lang] || STRINGS[key]?.en || key;
}

export function detectLang(): LangCode {
  const l = (typeof navigator !== 'undefined' && navigator.language?.toLowerCase()) || '';
  if (l.startsWith('vi')) return 'vi';
  if (l.startsWith('zh')) return 'zh';
  if (l.startsWith('ja')) return 'ja';
  if (l.startsWith('th')) return 'th';
  if (l.startsWith('id') || l.startsWith('ms')) return 'id';
  if (l.startsWith('es')) return 'es';
  return 'en';
}

const STORAGE_KEY = 'kra-map-lang';

export function loadLang(): LangCode {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && LANG_SET.has(saved)) return saved as LangCode;
  } catch {}
  return detectLang();
}

export function saveLang(lang: LangCode): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {}
}
